import { createReducer, on } from '@ngrx/store';
import * as BcpActions from './bcp.actions';

export const bcpFeatureKey = 'bcp';

export interface State {
  bcps: any[];
  count: number;
  recoveryPhases: any[];
  bcpScenarios: any[];
  adInfo: any;
  staffRequirements: any;
}

export const initialState: State = {
  bcps: [],
  count: 0,
  recoveryPhases: [],
  bcpScenarios: [],
  adInfo: {},
  staffRequirements: {
    payload: {
      locationId: null,
      biaIds: [],
    },
    records: [],
  },
};

export const reducer = createReducer(
  initialState,

  on(BcpActions.loadBcpsSuccess, (state, action) => ({
    ...state,
    bcps: action.bcps,
    count: action.count,
  })),
  on(BcpActions.loadBcpRecoveryPhaseSuccess, (state, action) => ({
    ...state,
    recoveryPhases: action.recoveryPhases,
  })),
  on(BcpActions.loadBcpScenariosSuccess, (state, action) => ({
    ...state,
    bcpScenarios: action.scenarios,
  })),
  on(BcpActions.deleteRecoveryPhaseSuccess, (state, action) => ({
    ...state,
    recoveryPhases: state.recoveryPhases.filter((rp) => rp.id !== action.id),
  })),

  on(BcpActions.loadAdInfoSuccess, (state, action) => {
    return {
      ...state,
      adInfo: {
        ...state.adInfo,
        [action.id]: action.adInfoes,
      },
    };
  }),
  on(BcpActions.addOrUpdateAdInfoSuccess, (state, action) => {
    let itExists = false;
    const adInfo = state.adInfo[action.id].map((ai) => {
      if (ai.id === action.adInfo.id) {
        itExists = true;
        return action.adInfo;
      } else {
        return ai;
      }
    });
    if (!itExists) adInfo.push(action.adInfo);

    return {
      ...state,
      adInfo: {
        ...state.adInfo,
        [action.id]: adInfo,
      },
    };
  }),
  on(BcpActions.loadStaffRequirementsSuccess, (state, action) => {
    return { ...state, staffRequirements: action };
  })
);
